<style
  lang="postcss"
  scoped
>
.goods-info {
  width: 100%;

  & img {
    width: 0.64rem;
    height: 0.64rem;
    object-fit: cover;
    margin-right: 0.08rem;
  }

  & .goods-extra {
    min-height: 0.64rem;

    &>div {
      width: 100%;
    }
  }

  & .flag {
    background: var(--base-color);
    color: #fff;
    border-radius: 0.04rem;
    padding: 0.02rem;
    font-size: 0.1rem;
    line-height: 1;
  }

  & .text-2 {
    max-height: 0.36rem;
    line-height: 0.18rem;
    color: #333;
  }

  & .type {
    color: #aaa;
    font-size: 0.11rem;
  }

  & .estimate {
    font-size: 0.1rem;
    margin-left: 0.1rem;
    color: var(--base-color);

    & span {
      line-height: 1;
    }

    &>>>span {
      font-size: inherit;
    }
  }
}
</style>
<template>
  <div
    class="goods-info"
    v-if="exist"
  >
    <div class="flex-center-center">
      <img
        :src="imgSize(item.goods_image_url || item.image_url || item.goods_img_360, 'n2')"
        alt=""
      />
      <div class="flex-1 flex-column flex-between goods-extra">
        <div class="flex text-2">
          <template v-if="hasPromotion(item)">
            <span
              class="flag"
              v-for="(v,k) in item.goods_promotion_name"
              :key="k"
            >{{ v }}</span>
          </template>
          {{ item.goods_name }}</div>
        <div
          class="type"
          v-if="item.goods_spec"
        >{{ item.goods_spec }}</div>
        <div
          class="type valid-date"
          v-if="item.goods_in_date_text"
        >{{ item.goods_in_date_text }}</div>
        <div class="flex-between">
          <div class="flex-left-bottom">
            <my-coin
              :coin="item.goods_price"
              :convertCoin="item.goods_usd_price"
              :style="{fontSize:'0.15rem'}"
              v-if="item.goods_price"
            />
            <div
              class="flex-center-center estimate"
              v-if="item.estimatePrice"
            >
              <span>预估到手价：</span>
              <my-coin :coin="item.estimatePrice"/>
            </div>
            <div
              class="flex-center-center estimate"
              v-if="item.goods_pay_price"
            >
              <span>实付金额：</span>
              <my-coin :coin="item.goods_pay_price"/>
            </div>
          </div>
          <span v-if="isLogicDot"><my-coin
            :coin="item.goods_marketprice"
            style="text-decoration: line-through;"
          /></span>
          <span v-else-if="item.goods_num || item.quantity">&times;{{ item.goods_num || item.quantity }}</span>
        </div>
      </div>
    </div>
    <slot/>
  </div>
</template>
<script>
import Coin from "./Coin/Index.vue"
import { siteConfig } from "@/config"
import MyCoin from "@/components/Coin.vue"
import goods from "@/mixins/goods"

const { isLogicDot = false } = siteConfig
export default {
  name: "MyGoods",
  mixins: [goods],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    MyCoin,
    [Coin.name]: Coin
  },
  computed: {
    exist() {
      return Object.keys(this.item).length > 1
    }
  },
  data() {
    return {
      isLogicDot
    }
  }
}
</script>
